import { logOut } from "../auth/Auth";
import Storage from "./Storage";

/*eslint no-restricted-globals: 0 */

export default class API {
    dev = true;
    url = "https://api.trend.toptest.eu/api";
    routes = {};

    constructor(routes) {
        this.routes = routes;

        if (window.location.href.indexOf("zonemediadev") > -1 || window.location.href.indexOf("localhost") > -1) {
            // this.url = "https://trendapi.zonemediadev.sk/api";
        }

    }

    route(name, params = {}, local = false) {
        let route = this.routes[name];
        for (let key in params) {
            if (params.hasOwnProperty(key)) {
                route = route.replace(":" + key, params[key]);
            }
        }

        if (local) {
            return location.protocol + "//" + location.hostname + route;
        }

        return this.url + route;
    }

    async request(args) {

        const def = {
            method: "get",
            data: false,
            route: false,
            loader: true,
            local: false,
            params: {},
            cache: false,
            done: (response, promise) => {
            },
            success: (response, promise) => {
            },
            created: (response, promise) => {
            },
            failure: (response, promise) => {
                // Run on different "thread"
                //setTimeout(() => {
                    //console.log(response.message);
                    //alert(response.message);
               // });
                var event = new CustomEvent('newAlert', {
                    detail:{
                        alert: {
                            type: "danger",
                            text: response.message
                        }
                    }
                });
                document.dispatchEvent(event);
            },
            error: (response) => {
                // Run on different "thread"
                //setTimeout(() => {
                    //console.log(response.message);
                    //alert(translate("Please contact system administrator.") + "\n\n" + response.message);
                //})
                var event = new CustomEvent('newAlert', {
                    detail:{
                        alert: {
                            type: "info",
                            text: response.message
                        }
                    }
                });
                document.dispatchEvent(event);
            }
        };

        // Merge arguments with defaults
        args = Object.assign(def, args);

        // Global cache disable
        args.cache = false;

        let body = undefined;

        if (args.data) {
            body = new FormData();
            body.append("data", JSON.stringify(args.data));
            if (args.data.files) {
                for (let i = 0; i < args.data.files.length; i++) {
                    const file = args.data.files[i];
                    body.append(file.name, file);
                }
            }
            args.method = "post";
        }

        let url = this.route(args.route, args.params, args.local);

        let active_weaveGroup_filter = Storage.get("weaveGroup_filter", true);
        let active_weaves_filter = Storage.get("weaves_filter", true);

        if (active_weaveGroup_filter !== null) {
            url += (url.indexOf("?") > -1 ? "&" : "?") + "weaveGroup=" + active_weaveGroup_filter.id;
        }

        if (active_weaves_filter !== null) {
            url += (url.indexOf("?") > -1 ? "&" : "?") + "weave=" + active_weaves_filter.id;
        }

        if (args.loader) {
            document.getElementById("ajax_loading").style.display = "block";
            document.getElementById("ajax_loading").style.position = "fixed";
            document.getElementById("ajax_loading").style.zIndex = "999999";
        }

        const promise = await fetch(url,
            {
                method: args.method,
                body: body,
                headers: {
                    "Authentication-Token": Storage.get("atoken")
                }
            });
        const response = await promise.json();

        if (args.loader) {
            document.getElementById("ajax_loading").style.display = "none";
            document.getElementById("ajax_loading").style.zIndex = "999999";
        }

        args.done(response, promise);

        switch (promise.status) {
            case 200: {
                args.success(response, promise);
                break;
            }
            case 201: {
                args.created(response, promise);
                break;
            }
            case 401: {
                alert(response.message);
                logOut();
                break;
            }
            case 400: {
                args.error(response, promise);
                break;
            }
            case 404: {
                args.failure(response, promise);
                break;
            }
            default: {
                //alert(promise.status);
                args.error(response, promise);
            }
        }

    }

}


// WEBPACK FOOTER //
// ./src/modules/base/API.js